const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class TrustpilotWidget extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.populateReviews()
    this.createReviewCard = this.createReviewCard.bind(this)
  }

  populateReviews () {
    fetch(
      'https://daniella-draper-new.by-association-only.workers.dev/api/trustpilot/reviews/',
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        return response.json()
      })
      .then((response) => {
        const reviews = response.data.reviews || []

        reviews.forEach((review) => {
          this.createReviewCard(review)
        })

        this.carousel = this.setupCarousel()
      })
      .catch((error) => {
        console.error('❌ Trustpilot Fetch error:', error)
      })
  }

  createReviewCard (review) {
    const truncatedText = (() => {
      const t = review?.text ?? ''
      return t.length > 300 ? `${t.slice(0, 300)}...` : t
    })()

    const trustpilotStarEmptyIcon =
      this.els.starsEmpty?.element.innerHTML || '☆'
    const trustpilotStarFullIcon = this.els.starsFull?.element.innerHTML || '★'

    const userLocale =
      (typeof navigator !== 'undefined' &&
        (navigator.languages?.length
          ? navigator.languages[0]
          : navigator.language)) ||
      'en-US'

    const formattedDate = review.createdAt
      ? new Date(review.createdAt).toLocaleDateString(userLocale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
      : ''

    const html = `<div class="keen-slider__slide sec-TrustPilot_Review" data-trustpilot-widget-el="slide">
      <div class="sec-TrustPilot_ReviewStars">
      ${trustpilotStarFullIcon.repeat(review.stars)}${trustpilotStarEmptyIcon.repeat(5 - review.stars)}
      </div>

      <h5 class="sec-TrustPilot_ReviewTitle fz-16_130">
        ${review.title}
      </h5>

      <p class="sec-TrustPilot_ReviewText fz-13_150">
        ${truncatedText}
      </p>

      <div class="sec-TrustPilot_ReviewAuthorContainer">
        <p class="sec-TrustPilot_ReviewAuthor fz-13_130">
          ${review.consumer.displayName}
        </p>

        <p class="sec-TrustPilot_ReviewDate fz-13_130">
          ${formattedDate}
        </p>
      </div>
    </div>`

    this.els.slides.element.innerHTML += html
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 10,
          origin: 'center',
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

window.customElements.define('trustpilot-widget', TrustpilotWidget)
